import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scroll() {
    // Find the actual scrolling element by walking up the DOM
    let el = this.element
    while (el) {
      if (el.scrollTop > 0) {
        el.scrollTo({ top: 0, behavior: "smooth" })
        return
      }
      el = el.parentElement
    }

    // Fallback: try all elements with overflow
    document.querySelectorAll("*").forEach(node => {
      if (node.scrollTop > 0) {
        node.scrollTo({ top: 0, behavior: "smooth" })
      }
    })
  }
}
